// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "sitechromepublisher/" + (chunkId === 543 ? "translations" : chunkId) + "." + {"422":"97c8b607079c2984dbb4","543":"ac116cfa6c2224cefbbe"}[chunkId] + ".js";
};